








import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {deleteSupplier} from '@/services/SupplierService';
import {ISupplier} from '@/models/ISupplier';
import {Confirm} from '@/decorators/ConfirmDialogDecorator';
import {ModuleShop} from '@/store/modules/ShopModule';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';

@Component({})
export default class RemoveSupplierBtn extends Vue {
  @Prop() supplier!: ISupplier;
  loading: boolean = false;

  get shopId() {
    return ModuleShop.shopId;
  }

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  @Confirm('Confirmation', 'Are you sure?')

  async submit() {
    try {
      this.loading = true;
      const success = await deleteSupplier(this.organizationId, this.shopId, this.supplier.id);
      if (success) {
        this.$emit('delete');
      }
    } finally {
      this.loading = false;
    }
  }
}
